import React from 'react';
import config from 'src/config';
import {Link} from 'react-router';
import CartComponent from 'src/components/Cart/CartComponent';

export default function HeaderCart(props) {
  return (
    <Link
      className="m-r-1_5"
      to={config.routes.basket}>
      <CartComponent
        items={props.cartItemsCount}
        empty={props.cartItemsCount == 0 } />
    </Link>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/elements/HeaderCart.jsx
 **/